import * as ACTION_TYPES from './types';

const initialState = {
  status: -1,
  error: null,
  list: [],
};

export default function reducer(state = initialState, action) {
  const { type, error, payload } = action;

  switch (type) {
    case ACTION_TYPES.COMPANIES_GET_REQUESTED:
      return {
        ...state,
        status: 0,
      };
    case ACTION_TYPES.COMPANIES_GET_SUCCEED:
      return {
        ...state,
        status: 1,
        list: payload.data,
      };
    case ACTION_TYPES.COMPANIES_GET_FAILED:
      return {
        ...state,
        status: 2,
        error,
      };
    default:
      return state;
  }
}
